import { render, staticRenderFns } from "./Startpage.vue?vue&type=template&id=7dec1b3b&"
import script from "./Startpage.ts?vue&type=script&lang=ts&"
export * from "./Startpage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Startpage.vue"
export default component.exports